var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,30c7.7,0,14-6.3,14-14c0-7.7-6.3-14-14-14C8.3,2,2,8.3,2,16C2,23.7,8.3,30,16,30z M14.3,8.3 C15,7,17,7,17.7,8.3l6.5,11.2c0.8,1.3-0.2,3-1.7,3H9.5c-1.5,0-2.5-1.7-1.7-3L14.3,8.3z M16.9,12.7c0-0.6-0.4-1-1-1s-1,0.4-1,1v3.7 c0,0.6,0.4,1,1,1s1-0.4,1-1V12.7z M16,18.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1 C17.1,18.6,16.6,18.2,16,18.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgWarning);
export default __webpack_public_path__ + "static/media/imgWarning.2c0e302162657e3526926075bfe92216.svg";
export { ForwardRef as ReactComponent };